<script setup>
import AgentLayout from "@/views/layouts/AgentLayout.vue";
import AgentsBoard from "@/components/analytics/AgentsBoard.vue";
</script>

<template>
  <AgentLayout full-width>
    <AgentsBoard />
  </AgentLayout>
</template>
